"use client";

import { useMarket } from "#/store/app/portfolio/market";
import { type Market } from "#/types/markets";

export const usePerpInstrumentName = (market?: Market) => {
  const { market: currentMarket } = useMarket();

  const effectiveMarket = market ?? currentMarket;

  return { perpInstrumentName: `${effectiveMarket.pair}-PERPETUAL` };
};
